export default {
  '@type': 'MerchantReturnPolicy',
  'applicableCountry': 'CH',
  'merchantReturnLink': 'https://www.timberland.ch/en-ch/customer-care/returns',
  'returnPolicyCategory': 'https://schema.org/MerchantReturnFiniteReturnWindow',
  'returnMethod': 'https://schema.org/ReturnByMail',
  'merchantReturnDays': 30
}
